import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { cleanPageMenu, retrievePageMenu } from "../../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../../redux/store";
import LoadingComp from "../../../components/re-usable/loading/loading";

const WhoWeAreComponent = () => {
  const path = "%2FWho-We-Are";
  const dispatch = useAppDispatch();

  const [pageTitle, setPageTitle] = useState("");
  const [description, setDescription] = useState("");

  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);

  useEffect(() => {
    dispatch(retrievePageMenu(path));

    return () => {
      dispatch(cleanPageMenu());
    };
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]?.result[0]?.menuItemName) {
      setPageTitle(`${RapsEuropeData[0].result[0].menuItemName} | RAPS`);
    }

    if (RapsEuropeData[0]?.result[0]?.description) {
      setDescription(RapsEuropeData[0].result[0].description);
    }
  }, [RapsEuropeData]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      {pageTitle && (
        <>
          <Helmet>
            <title>{pageTitle}</title>
          </Helmet>
        </>
      )}
      <div dangerouslySetInnerHTML={{ __html: description }}></div>
    </>
  );
};

export default WhoWeAreComponent;
